import { render, staticRenderFns } from "./create-declare-group.vue?vue&type=template&id=41dc1552&scoped=true"
import script from "./create-declare-group.vue?vue&type=script&lang=ts"
export * from "./create-declare-group.vue?vue&type=script&lang=ts"
import style0 from "./create-declare-group.vue?vue&type=style&index=0&id=41dc1552&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dc1552",
  null
  
)

export default component.exports